import { useRef, useMemo, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useSearchFiltersContext } from '../../../context/SearchFiltersContext';

export const useProfessionalsList = () => {
  const listRef = useRef<HTMLDivElement>(null);
  const [searchParams] = useSearchParams();

  const {
    results: professionals,
    loading,
    error,
    pagination,
    filters,
    clearFilters,
    handleRemoveFilter,
    navigatePage,
    loadingSpecialties
  } = useSearchFiltersContext();

  const handlePageChange = (page: number) => {
    navigatePage(page);
    listRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  const hasActiveFilters = useMemo(() => Boolean(
    filters.q ||
    filters.dimension ||
    (filters.specialties && filters.specialties.length > 0)
  ), [filters]);

  const isFromSearch = useMemo(() => Boolean(
    searchParams.get('q')?.trim() ||
    searchParams.get('dimension') ||
    searchParams.get('specialties')
  ), [searchParams]);

  useEffect(() => {
    if (isFromSearch) {
      window.scrollTo({ top: 0, behavior: 'instant' });
    }
  }, [isFromSearch, searchParams]);

  return {
    professionals,
    loading: loading || loadingSpecialties,
    error,
    pagination,
    filters,
    hasActiveFilters,
    isFromSearch,
    listRef,
    handlePageChange,
    handleRemoveFilter,
    clearFilters
  };
};